import React, { useContext, useEffect } from 'react'
import Layout from '../../../components/layout/layout'
import '../mlOutRails/mlOutRails.scss'
import coverImage from '../../../images/articles/genai-photo.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'


const GenAi = () => {
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Seo
        title='Generative AI at Work: What Actually Delivers'
        description={translations.BlogGenAi1}
        type='article'
        image={coverImage}
        jsonLd={[
          articleJsonLd({
            headline: translations.BlogGenAi,
            description: translations.BlogGenAi1,
            image: coverImage,
            path: '/articles/genAi',
            datePublished: '2026-05-12',
            author: translations.BlogGenAi12,
          }),
          articleBreadcrumbs(translations.BlogGenAi, '/articles/genAi'),
        ]}
      />
      <div className='mlrole-health-container'>

        <div className='mlrole-health healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{translations.BlogGenAi}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{translations.BlogGenAi11}</p>
              <p>•</p>
              <p>{translations.BlogGenAi12}</p>
            </div>
            <p className='article-author-head'>{translations.BlogGenAi13}</p>
          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={coverImage} alt='Person working on a laptop with a pen in hand' className='mlrole-health-first-image' />
          </div>
          <ArticleListen />
          <ArticleSummary id='genAi' />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              <p>{translations.BlogGenAi1}</p>
              <p>{translations.BlogGenAi2}</p>

              <h2 className='article-secondaty-title'>{translations.BlogGenAi3}</h2>
              <p>{translations.BlogGenAi4}</p>
              <p>{translations.BlogGenAi5}</p>
              <p>{translations.BlogGenAi6}</p>

              <h2 className='article-secondaty-title'>{translations.BlogGenAi7}</h2>
              <p>{translations.BlogGenAi8}</p>
              <p>{translations.BlogGenAi9}</p>
              <p>{translations.BlogGenAi10}</p>
            </div>
          </div>

          <ArticleCta />
          <ArticleNextCta link='/articles/dataPrivacy' title={translations.BlogDataPrivacy} />
        </div>
      </div>
    </Layout>
  )
}

export default GenAi
